import { render, staticRenderFns } from "./FaultsReport.vue?vue&type=template&id=8e975a50&"
import script from "./FaultsReport.vue?vue&type=script&lang=js&"
export * from "./FaultsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports